//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Clipboard from 'clipboard';

export default {
  props: ['uname', 'gid', 'parentpage'],
  data() {
    return {
      wx: 'wx',
      phone: 'tel',
      u_name: this.uname,
      list: [],
    };
  },
  watch: {
    gid: function (val, oldVal) {
      this.get_list();
      this.getService();
    },
  },
  methods: {
    async getService() {
      let data = {
        goodsid: this.gid,
        page: this.u_name, //page1=1，page2=3，page3=2
        cid: this.$Glb.getAttribute().qd,
      };
      let res = await this.$getWxPhone(data);
      this.wx = res.data.wechat || this.wx;
      this.phone = res.data.phone || this.phone;
      this.$store.commit('setWx', this.wx);
      this.$store.commit('setFloat', res.data.float || 1);
    },
    //  复制微信
    copyWecat() {
      this.$Glb.baiduCount(`${this.baiduCount}微信客服`);

      let _this = this;
      var clipboard = new Clipboard('.copy_wx_btn');
      clipboard.on('success', (e) => {
        _this.$Glb.PlMessage('复制成功', 800, function () {
          window.location.href = 'weixin://';
        });
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on('error', (e) => {
        // 不支持复制
        _this.$Glb.PlMessage('该浏览器不支持一键复制,请长按手动复制', 800);
        // 释放内存
        clipboard.destroy();
      });
    },

    baiduTongji(text) {
      var page = '首页';
      if (this.u_name == 2) {
        page = '结果页';
      } else if (this.u_name == 3) {
        page = '解锁页';
      }
      this.$Glb.baiduCount(page + text);
    },

    get_list() {
      let data = {
        gid: this.gid, //产品id(1000001:八字精批  1000002:一生财运 1000003:十年大运  1000004:八字合婚 1000005:八字感情运 1000006:来生运)
        type: this.u_name, //页面区分(1为首页 2为结果页 3为全部)
        posId: this.$Glb.getAttribute().posId,
        qd: this.$Glb.getAttribute().qd,
        userId: '', //用户id
        deviceId: '', //设备id
      };
      this.$api.post('/v1/Relationproduct/index', data, (res) => {
        if (res.code === 1) {
          this.list = res.data;
        }
      });
    },
  },
  created() {
    this.getService();
  },
  mountrd() {},
};



// WEBPACK FOOTER //
// ./src/pages/yscy/components/footer.vue